module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-learn-site-thumbnail_de-f4f38f97889701b3bbd888b634967e90.png";